export interface GoodsSpec {
  name: string;
  options: string[];
}

export interface SelectedGoodsSpec {
  name: string;
  value: string;
}

export const normalizeGoodsSpecs = (specs?: GoodsSpec[]) => (specs || [])
  .map((item) => ({
    name: (item?.name || '').trim(),
    options: (item?.options || []).map((option) => (option || '').trim()).filter(Boolean),
  }))
  .filter((item) => item.name && item.options.length > 0)
  .map((item) => ({
    name: item.name,
    options: Array.from(new Set(item.options)),
  }));

export const normalizeSelectedSpecs = (specs?: SelectedGoodsSpec[]) => (specs || [])
  .map((item) => ({
    name: (item?.name || '').trim(),
    value: (item?.value || '').trim(),
  }))
  .filter((item) => item.name && item.value);

export const buildSelectedSpecs = (
  specs: GoodsSpec[],
  initialSelectedSpecs?: SelectedGoodsSpec[],
) => {
  const normalizedSpecs = normalizeGoodsSpecs(specs);
  const selectedMap = new Map(normalizeSelectedSpecs(initialSelectedSpecs).map((item) => [item.name, item.value]));
  return normalizedSpecs.map((item) => ({
    name: item.name,
    value: selectedMap.get(item.name) || item.options[0],
  }));
};

export const getGoodsSpecLines = (item: any) => {
  const selectedSpecs = normalizeSelectedSpecs(item?.selectedSpecs);
  if (selectedSpecs.length) {
    return selectedSpecs.map((spec) => `${spec.name}：${spec.value}`);
  }

  const specText = (item?.specText || '').trim();
  if (!specText) {
    return [];
  }

  return specText
    .split(/\s*\/\s*/u)
    .map((line: string) => line.trim())
    .filter((line: string) => Boolean(line));
};

export const getGoodsSpecText = (item: any) => {
  const lines = getGoodsSpecLines(item);
  if (!lines.length) {
    return '';
  }
  return lines.join(' / ');
};

export const getGoodsDisplayName = (item: any) => {
  const specText = getGoodsSpecText(item);
  if (!specText) {
    return item?.name || '-';
  }
  return `${item?.name || '-'}（${specText}）`;
};

export const buildGoodsCartKey = (goodsId: number, selectedSpecs?: SelectedGoodsSpec[]) => {
  const normalizedSelectedSpecs = normalizeSelectedSpecs(selectedSpecs);
  if (!normalizedSelectedSpecs.length) {
    return `${goodsId}::default`;
  }
  return `${goodsId}::${normalizedSelectedSpecs.map((item) => `${item.name}:${item.value}`).join('|')}`;
};
